import { countryFlagUrl } from "@/lib/countries";
import { imageUrl } from "@/lib/api";
import { Crown, Trophy, Star } from "lucide-react";

function Icon({ tip, children, color = "bg-neutral-900" }) {
  return (
    <span
      title={tip}
      className={`inline-flex h-5 w-5 items-center justify-center rounded-full ${color} text-white`}
    >
      {children}
    </span>
  );
}

export function PlayerCard({ player, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group text-left w-full"
      data-testid={`player-card-${player.id}`}
    >
      <div className="relative aspect-square w-full overflow-hidden bg-neutral-100 border border-border">
        {player.photo_path ? (
          <img
            src={imageUrl(player.photo_path)}
            alt={player.name}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-neutral-300">
            <div className="relative w-16 h-16">
              <div className="absolute inset-0 rounded-full othello-disc-dark" />
              <div className="absolute top-1 left-1 w-6 h-6 rounded-full othello-disc" />
            </div>
          </div>
        )}
        <div className="absolute top-2 right-2 flex gap-1">
          {player.is_female && (
            <Icon tip="Female" color="bg-pink-600">
              <span className="text-[10px] font-bold">F</span>
            </Icon>
          )}
          {player.is_youth && (
            <Icon tip="Youth" color="bg-amber-500">
              <span className="text-[10px] font-bold">Y</span>
            </Icon>
          )}
          {player.is_star && (
            <Icon tip="Star" color="bg-yellow-400">
              <Star className="h-3 w-3 fill-current" />
            </Icon>
          )}
          {player.is_trophy && (
            <Icon tip="Past Champion" color="bg-primary">
              <Trophy className="h-3 w-3" />
            </Icon>
          )}
        </div>
      </div>
      <div className="mt-2">
        <div className="text-sm font-semibold leading-tight group-hover:text-primary transition-colors">
          {player.name}
        </div>
      </div>
    </button>
  );
}

export function CountryBlock({ team }) {
  return (
    <section className="mb-14" data-testid={`country-block-${team.country_code}`}>
      <div className="flex items-center gap-4 mb-6 border-b border-border pb-3">
        <img
          src={countryFlagUrl(team.country_code)}
          alt={team.country_name}
          className="h-8 w-12 object-cover border border-border"
        />
        <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
          {team.country_name}
        </h2>
        <span className="ml-auto text-xs uppercase tracking-[0.2em] text-muted-foreground">
          {team.players.length} player{team.players.length !== 1 ? "s" : ""}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5">
        {team.players.map((p) => (
          <PlayerCard key={p.id} player={p} />
        ))}
      </div>
    </section>
  );
}
